import { render, staticRenderFns } from "./SevereAsthma.vue?vue&type=template&id=fc876380&scoped=true"
import script from "./SevereAsthma.vue?vue&type=script&lang=js"
export * from "./SevereAsthma.vue?vue&type=script&lang=js"
import style0 from "./SevereAsthma.vue?vue&type=style&index=0&id=fc876380&prod&lang=scss&scoped=true"
import style1 from "./SevereAsthma.vue?vue&type=style&index=1&id=fc876380&prod&lang=scss"
import style2 from "./SevereAsthma.vue?vue&type=style&index=2&id=fc876380&prod&lang=scss&scoped=true"
import style3 from "./SevereAsthma.vue?vue&type=style&index=3&id=fc876380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc876380",
  null
  
)

export default component.exports